import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Guard } from '../../components/layout/Guard';

const List = lazy(() => import('./InvoiceListPage'));
const Detail = lazy(() => import('./InvoiceDetailPage'));
const Form = lazy(() => import('./InvoiceFormPage'));

const routes: RouteObject[] = [
  { path: '/invoices', element: <Guard any={['invoice.read']}><List /></Guard> },
  { path: '/invoices/new', element: <Guard any={['invoice.create']}><Form /></Guard> },
  { path: '/invoices/:id', element: <Guard any={['invoice.read']}><Detail /></Guard> },
  { path: '/invoices/:id/edit', element: <Guard any={['invoice.create']}><Form /></Guard> },
];
export default routes;
